import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AttachmentList, Drawer } from "@outpave/ds";
import { useDisplayAttachments } from "hooks/useDisplayAttachments";
import { toAttachmentItems } from "utils/attachments/attachmentItems";
import {
  useAttachmentListLabels,
  useAttachmentViewerLabels,
} from "hooks/useAttachmentLabels";
import { LocalImageAsset } from "hooks/useAttachmentAndAssetHandling";

interface AttachmentDrawerProps {
  openAttachmentDrawer: boolean;
  handleCloseAttachmentDrawer: () => void;
  drawerTitle?: string;
  localAssets: LocalImageAsset[];
}

const ViewOnlyAttachmentDrawer = (props: AttachmentDrawerProps) => {
  const {
    openAttachmentDrawer,
    handleCloseAttachmentDrawer,
    drawerTitle = "Attachments",
    localAssets,
  } = props;
  const { t } = useTranslation();
  const attachmentLabels = useAttachmentListLabels();
  const viewerLabels = useAttachmentViewerLabels();
  const { printAsset, downloadAsset } = useDisplayAttachments({
    allAttachments: localAssets || [],
  });
  const files = toAttachmentItems(localAssets || [], t("Attachment"));

  return (
    <Drawer
      open={openAttachmentDrawer}
      onClose={handleCloseAttachmentDrawer}
      title={t(drawerTitle)}
      footer={
        <Button variant="default-soft" onClick={handleCloseAttachmentDrawer}>
          {t("Back")}
        </Button>
      }
    >
      {/* The package ships no empty-state label, and with no `onAdd`
          there is no dropzone either, so an empty list renders nothing
          at all. The message the old component showed stays here. */}
      {files.length > 0 ? (
        <AttachmentList
          files={files}
          labels={attachmentLabels}
          viewer={{ labels: viewerLabels, filmstrip: true }}
          onDownload={(item) => item.url && downloadAsset(item.url)}
          onPrint={(item) => item.url && printAsset(item.url)}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 64,
            color: "var(--color-text-secondary)",
          }}
        >
          {t("No files found")}
        </Box>
      )}
    </Drawer>
  );
};

export default ViewOnlyAttachmentDrawer;
